var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 39,
    viewBox: "0 0 135 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.09228 0C-0.147096 0.916078 -0.40707 5.72549 0.242865 8.01568L6.09228 34.3529C6.09228 38.0172 10.1544 38.9333 12.1855 38.9333H124.056C127.955 39.6204 129.743 34.83 130.149 32.349L134.78 8.01568C135.949 2.29019 132.18 0.286274 130.149 0H6.09228Z",
    fill: "url(#paint0_linear_458_13)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_458_13",
    x1: 45,
    y1: -0.00000765232,
    x2: 95,
    y2: 39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70D521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1E40C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector5);
export default __webpack_public_path__ + "static/media/Vector-5.fde07b83ecd9aa1cf2c172968f8e7e80.svg";
export { ForwardRef as ReactComponent };